import {ActionContext, ActionTree} from 'vuex';
import {RootState} from '@/store/type';
import {HttpService} from '@/services/api';
import {ChangePassword, Member, MemberInitState, ResponseMember} from '@/store/member/member.types';
import {MemberEnumApi} from '@/store/member/member.enum';
import {Invite, ServiceFormSearch} from '@/class/service-form.interface';
import {AxiosResponse} from 'axios';

export const MemberAction: ActionTree<MemberInitState, RootState> = {
  async _getMember(req: ActionContext<MemberInitState, RootState>, params?: Member): Promise<void> {
    let {commit} = req;
    try {
      let member = await HttpService.get(MemberEnumApi.member, params) as { data: ResponseMember };
      if (member.data.appCode === 20000) {
        commit('mutationGetMember', member.data.data);
      } else {
        commit('mutationGetMember', []);
      }
    } catch (e) {
      commit('mutationGetMember', []);
      console.error('DEBUG: _getMember ', e.message);
    }
  },
  async _getMemberByBranchId(req: ActionContext<MemberInitState, RootState>, params: string): Promise<void> {
    let {commit} = req;
    try {
      let member = await HttpService.get(`${MemberEnumApi.member}branch/${params}`, params) as { data: ResponseMember };
      if (member.data.appCode === 20000) {
        commit('mutationGetMember', member.data.data);
      } else {
        commit('mutationGetMember', []);
      }
    } catch (e) {
      commit('mutationGetMember', []);
      console.error('DEBUG: _getMember ', e.message);
    }
  },
  async _registerMember(req: ActionContext<MemberInitState, RootState>, payload: Member): Promise<void> {
    try {
      let res = await HttpService.post(`${MemberEnumApi.member}register`, payload);
      return res;
    } catch (e) {
      console.error('DEBUG: _insertMember ', e.message);
    }
  },
  async _updateMember(req: ActionContext<MemberInitState, RootState>, payload: Member): Promise<void> {
    try {
      let res = await HttpService.put(MemberEnumApi.member, payload);
      return res;
    } catch (e) {
      console.error('DEBUG: _updateMember ', e.message);
    }
  },
  async _getMemberFromService(req: ActionContext<MemberInitState, RootState>, payload: ServiceFormSearch): Promise<void> {
    try {
      let {commit} = req;
      let res = await HttpService.post(MemberEnumApi.member + 'search-member-form-service', payload);
      await commit('mutationGetMemberFromService', res.data.data);
      return res;
    } catch (e) {
      console.error('DEBUG: _updateMember ', e.message);
    }
  },
  _setFormSearch: ({commit}: ActionContext<MemberInitState, RootState>, payload: ServiceFormSearch): void => commit('mutationSetFormSearch', payload),
  async _inviteMember(req: ActionContext<MemberInitState, RootState>, payload: Invite[]): Promise<void> {
    try {
      let {commit} = req;
      let res = await HttpService.post(MemberEnumApi.member + 'invite', payload);
      await commit('mutationGetMemberFromService', []);
      return res;
    } catch (e) {
      console.error('DEBUG: _updateMember ', e.message);
    }
  },
  _setInviteList: ({commit}: ActionContext<MemberInitState, RootState>, payload: Invite[]): void => commit('mutationSetInviteList', payload),
  async _updatePasswordMember(req: ActionContext<MemberInitState, RootState>, payload: ChangePassword): Promise<void> {
    try {
      return await HttpService.put(`${MemberEnumApi.member}password`, payload)
    } catch (e) {
      console.error('DEBUG: _updatePassword ', e.message);
    }
  },
  async _getTimeInformation({commit, dispatch}) {
    try {
      let res = await HttpService.get(`${MemberEnumApi.member}time-information`) as AxiosResponse;
      await dispatch('handle/_httpResponse', res, {root: true});
      await commit('mutationSetTimeInformation', res.data.data[0]);
      return res
    } catch (e) {
      throw e;
    }
  },
  async _getMemberById(req: ActionContext<MemberInitState, RootState>, params: string): Promise<void> {
    let {commit} = req;
    try {
      let member = await HttpService.get(`${MemberEnumApi.member}${params}`, params);
      if (member.data.appCode === 20000) {
        commit('mutationGetMemberProfile', member.data.data[0] as Member);
      } else {
        commit('mutationGetMemberProfile', {});
      }
    } catch (e) {
      commit('mutationGetMemberProfile', {});
      console.error('DEBUG: _getMemberById ', e.message);
    }
  },
  async _getBondsmanById(req: ActionContext<MemberInitState, RootState>, params: string): Promise<void> {
    let {commit} = req;
    try {
      let member = await HttpService.get(`${MemberEnumApi.member}${params}`, params);
      if (member.data.appCode === 20000) {
        commit('mutationGetMemberBondsman', member.data.data[0] as Member);
      } else {
        commit('mutationGetMemberBondsman', {});
      }
    } catch (e) {
      commit('mutationGetMemberBondsman', {});
      console.error('DEBUG: _getBondsmanById ', e.message);
    }
  },
  async _getTimeInformationById(req: ActionContext<MemberInitState, RootState>): Promise<void> {
    let {commit} = req;
    try {
      let time = await HttpService.get(`${MemberEnumApi.member}time-information`);
      let timeTransactions = time.data.data[0].timeTransactions;
      if (timeTransactions.length === 0) {
        commit('mutationTimeTotal', 0);
      } else {
        commit('mutationTimeTotal', timeTransactions[0].remain);
      }
    } catch (e) {
      commit('mutationTimeTotal', 0);
    }
  },
  async _getTimeVisitorInformationById(req: ActionContext<MemberInitState, RootState>, memberId: string): Promise<void> {
    try {
      let {commit} = req;
      let time = await HttpService.get(`${MemberEnumApi.member}time-information/${memberId}`);
      let timeTransactions = time.data.data[0].timeTransactions;
      let remain = '0';
      if (timeTransactions.length) {
        remain = timeTransactions[0].remain;
      }
      commit('mutationSetVisitorRemain', remain);
    } catch (e) {
      throw e;
    }
  },
  async _deleteMemberService(req: ActionContext<MemberInitState, RootState>, payload: string): Promise<void> {
    try {
      let res = await HttpService.delete(`${MemberEnumApi.memberServices}`, payload);
      return res;
    } catch (e) {
      console.error('DEBUG: _deleteSubService ', e.message);
    }

  },
  async _getBondsmanByBranchIdForRegister(req: ActionContext<MemberInitState, RootState>): Promise<void> {
    let {commit} = req;
    try {
      let members = await HttpService.get(`${MemberEnumApi.member}branch/bondsman`) as { data: ResponseMember };
      if (members.data.appCode === 20000) {
        commit('mutationGetMember', members.data.data);
      } else {
        commit('mutationGetMember', []);
      }
    } catch (e) {
      commit('mutationGetMember', []);
      console.error('DEBUG: _getMemberByBranchIdForRegister ', e.message);
    }
  },
  async _getCheckMobilePhone(req: ActionContext<MemberInitState, RootState>, params: string): Promise<void> {
    let {commit} = req;
    try {
      let member = await HttpService.get(`${MemberEnumApi.member}check/mobile/${params}`) as { data: ResponseMember };
      commit('mutationCheckMobile',Number(member.data.total));
    } catch (e) {
      commit('mutationCheckMobile', 1);
      console.error('DEBUG: _getCheckMobilePhone ', e.message);
    }
  },
  async _getStarByMemberId(req: ActionContext<MemberInitState, RootState>, params: string): Promise<void> {
    let {commit} = req;
    try {
      let member = await HttpService.get(`${MemberEnumApi.member}star/${params}`) as { data: ResponseMember };
      commit('mutationSetStartTransaction',member.data.data);
    } catch (e) {
      commit('mutationSetStartTransaction',[]);
      throw e;
    }
  },
  _setVisitorId: ({commit}: ActionContext<MemberInitState, RootState>, visitorId: string) => commit('mutationSetVisitorId', visitorId),
  async _updateMemberServices(req: ActionContext<MemberInitState, RootState>, payload: Member): Promise<void> {
    try {
      let res = await HttpService.put(`${MemberEnumApi.member}service`, payload);
      return res;
    } catch (e) {
      console.error('DEBUG: _updateMember ', e.message);
    }
  },
};
